"use strict";
// Copyright 2022 Fergal Daly <fergald@gmail.com>.
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTo = defaultTo;
function defaultTo(map, key, valueMaker) {
    const value = map.get(key);
    if (value !== undefined) {
        return value;
    }
    const newValue = valueMaker();
    map.set(key, newValue);
    return newValue;
}
